/*
 * File: ContactCard.tsx
 * Project: a-a
 * File Created: Tuesday, 4th November 2025 12:00:53 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 18th November 2025 12:39:12 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import zeplinColor from '../../../../../theme/Color';
import CustomAlert from '../../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../../shared/CustomAlert/CustomAlertContain';
import CustomPopOver from '../../../../shared/CustomPopOver/CustomPopOver';
import { ReactComponent as CopyLinkIcon } from '../../../../../assets/copy-link.svg';

const ContactCard = ({ data, loading }: { data: any; loading: boolean }) => {
  const theme = useTheme();
  const details = data;
  const [contactAnchorEl, setContactAnchorEl] = useState<HTMLDivElement | null>(null);
  const openContact = Boolean(contactAnchorEl);
  const idContact = openContact ? 'simple-popover' : undefined;
  const [emailLink, setEmailLink] = useState('');
  const [phone, setPhone] = useState('');
  const [copy, setCopy] = useState('');
  const handleCopyLink = (val: any, type: string) => {
    // console.log() .
    navigator.clipboard.writeText(val);
    setCopy(`${type} copied`);
  };
  const handleClose = () => {
    setCopy('');
  };
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();
    setContactAnchorEl(event.currentTarget);
  };
  return (
    <Box
      sx={{
        borderRadius: '14px',
        backgroundColor: zeplinColor.Neutral3,
        padding: '12px',
        display: 'flex',
        gap: '12px',
        flex: 1,
      }}
    >
      {loading ? (
        <Skeleton
          variant='rounded'
          width={'56px'}
          height={56}
          sx={{ backgroundColor: zeplinColor.Neutral4 }}
        />
      ) : (
        <img
          // className={style['avatar']}

          src={details?.picture || ''}
          alt='logo'
          loading='lazy'
          style={{ objectFit: 'fill', borderRadius: '14px', width: '56px', height: '56px' }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = '/assets/profile.svg';
          }}
        />
      )}
      {/* ) : (
      <Typography variant='display4' sx={{ color: zeplinColor.Neutral1 }}>
        {details?.accountName
          ?.split(' ')
          .map((val: any, index: number) =>
            index === 0 || index === details?.accountName?.split(' ').length - 1 ? val[0] : '',
          )}
      </Typography> */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '100%',
                backgroundColor: zeplinColor.Neutral4,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              {' '}
              <Typography variant='responsiveBody2'>
                {details?.firstName} {details?.lastName}
              </Typography>
              <img
                // className={style['avatar']}
                src={'/assets/linkedin-link.svg'}
                alt='logo'
                loading='lazy'
                style={{ objectFit: 'fill', width: '18px', height: '18px' }}
              />
            </Box>
          )}
          {/* <Chip
            label={
              loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '100%',
                    backgroundColor: zeplinColor.Neutral4,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography
                  variant='responsiveLabel1'
                  sx={{ display: 'flex', alignItems: 'center' }}
                  color={zeplinColor.BasicBlack}
                >
                  No engagement
                </Typography>
              )
            }
            sx={{
              backgroundColor: zeplinColor.Neutral4,
              color: zeplinColor.Neutral1,
              '&.MuiChip-root': {
                height: '24px',
                padding: '5px 12px',
                borderRadius: '50px',
              },
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          /> */}
        </Box>
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '100%',
              backgroundColor: zeplinColor.Neutral4,
              // Optionally adjust other styles here
            }}
          />
        ) : (
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            {data?.jobTitle || 'NA'}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {loading ? (
            <Skeleton
              variant='rounded'
              width={'20px'}
              height={'20px'}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : data?.email ? (
            <img
              // className={style['avatar']}
              onClick={(e: any) => {
                handleClick(e);
                setPhone('');
                setEmailLink(data?.email);
              }}
              src={'/assets/zoominfo-mail.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            />
          ) : (
            ''
          )}
          {loading ? (
            <Skeleton
              variant='rounded'
              width={'20px'}
              height={'20px'}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : data?.mobilePhone ? (
            <img
              // className={style['avatar']}
              onClick={(e: any) => {
                handleClick(e);
                setEmailLink('');

                setPhone(data?.mobilePhone);
              }}
              src={'/assets/zoominfo-call.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            />
          ) : (
            ''
          )}
          {/* {loading ? (
            <Skeleton
              variant='rounded'
              width={'20px'}
              height={'20px'}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : (
            <img
              // className={style['avatar']}
              src={'/assets/zoominfo-mobile.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            />
          )} */}
        </Box>
      </Box>
      <CustomPopOver
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        setAnchorEl={setContactAnchorEl}
        anchorEl={contactAnchorEl}
        id={idContact}
        sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            padding: '16px',
          }}
        >
          <Box
            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              handleCopyLink(phone ? phone : emailLink, phone ? 'Phone' : 'Email');
              setContactAnchorEl(null);
            }}
          >
            {/* <img src={'/assets/copy-link.svg'} width={18} height={18} /> */}
            <CopyLinkIcon width={18} height={18} />
            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              Copy
            </Typography>
          </Box>
          {emailLink && (
            <a
              href={`mailto:${emailLink}`}
              onClick={(e) => {
                e.stopPropagation();
                setContactAnchorEl(null);
                // handleCopyLink(data?.link);
              }}
              target='_blank'
              rel='noopener noreferrer'
              style={{ textDecoration: 'none' }}
            >
              <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                <img
                  // className={style['avatar']}

                  src={'/assets/zoominfo-mail.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', width: '18px', height: '18px' }}
                />
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  Email
                </Typography>
              </Box>
            </a>
          )}
        </Box>
      </CustomPopOver>

      <CustomAlert
        open={copy ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={copy}
            alertIcon={<img src='/assets/checkmark-green.png' width={24} height={24} />}
            error={false}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default ContactCard;
